import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResponsiveService {
  private _sidebarState = new BehaviorSubject<boolean>(false);
  sidebarState = this._sidebarState.asObservable();

  constructor(
    private breakpointObserver: BreakpointObserver
  ) { }

  openSidebar() {
    this._sidebarState.next(true);
  }

  closeSidebar() {
    this._sidebarState.next(false);
  }
  /**
   * checks screen size match with the dynamic breakpoint parameter
  */
    public checkScreenSizeDynamic(params:string | readonly string[]):Observable<BreakpointState> {
      return this.breakpointObserver.observe(params);
    }
  

  /**
   * checks screen size match when tablet or handset mode is ON
  */
  public checkScreenSize():Observable<BreakpointState> {
    return this.breakpointObserver.observe([Breakpoints.Tablet, Breakpoints.Handset]);
  }

  /**
   * checks screen size match when tablet portait mode is ON
   */
  public checkScreenTabletPortaitSize():Observable<BreakpointState> {
    return this.breakpointObserver.observe(Breakpoints.TabletPortrait);
  }

  /**
    * checks screen size match tablet landscape mode is ON
  */
  public checkScreenTabletLandscapeSize():Observable<BreakpointState> {
    return this.breakpointObserver.observe(Breakpoints.TabletLandscape)
  }

  /**
   * checks screen size match when handset portait mode is ON
   */
  public checkScreenHandsetPortaitSize():Observable<BreakpointState> {
    return this.breakpointObserver.observe(Breakpoints.HandsetPortrait);
  }
  

  /**
    * checks screen size match handset landscape mode is ON
  */
  public checkScreenHandsetLandscapeSize():Observable<BreakpointState> {
    return this.breakpointObserver.observe(Breakpoints.HandsetLandscape)
  }
}
